"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainLanding = void 0;
const react_1 = __importDefault(require("react"));
const MainLanding_elements_1 = require("./MainLanding.elements");
const components_1 = require("./components");
const MainLanding = ({}) => {
    return (react_1.default.createElement(MainLanding_elements_1.MainLandingWrap, null,
        react_1.default.createElement(components_1.Hero, null),
        react_1.default.createElement(components_1.SecondSection, null),
        react_1.default.createElement(components_1.ThirdSection, null),
        react_1.default.createElement(components_1.ForthSection, null)));
};
exports.MainLanding = MainLanding;
